export const countryCode = [
    {
      value: "673",
      label: "Brunei (+673)",
    },
    {
      value: "855",
      label: "Cambodia (+855)",
    },
    {
      value: "86",
      label: "China (+86)",
    },
    {
      value: "852",
      label: "Hong Kong (+852)",
    },
    {
      value: "62",
      label: "Indonesia (+62)",
    },
    {
      value: "856",
      label: "Lao People's Democratic Republic (+856)",
    },
    {
      value: "60",
      label: "Malaysia (+60)",
    },
    {
      value: "95",
      label: "Myanmar (+95)",
    },
    {
      value: "63",
      label: "Philippines (+63)",
    },
    {
      value: "65",
      label: "Singapore (+65)",
    },
    {
      value: "886",
      label: "Taiwan (+886)",
    },
    {
      value: "66",
      label: "Thailand (+66)",
    },
    {
      value: "84",
      label: "Viet Nam (+84)",
    },
    {
      value: "Others",
      label: "Others",
    },
  ];